import TasksPage from "./TaskList.page";

export default TasksPage;
